import type { HandleClientError } from '@sveltejs/kit';
import { goto } from '$app/navigation';

// Handle subdomain detection and redirect to demo routes
export const handleError: HandleClientError = async ({ error, event }) => {
  console.error('Client error:', error);

  return {
    message: 'An unexpected error occurred'
  };
};

// Commented out demo subdomain detection and redirect to /demo routes
// if (typeof window !== 'undefined') {
//   const hostname = window.location.hostname;
//   const pathname = window.location.pathname;

//   // Check if we're on demo subdomain and not already on a /demo route
//   if (hostname === 'demo.expoconnect.id' && !pathname.startsWith('/demo')) {
//     // Redirect to /demo with the current path
//     const newPath = pathname === '/' ? '/demo/login' : `/demo${pathname}`;
//     window.location.href = newPath;
//   }
// }

